<app-spinner class="spinner-position" *ngIf="showSpinner" [message]="spinnerMessage"></app-spinner>
<div *ngIf="isLIMSHosted === false" class="bpt-layout-wrapper" style="height: calc(93.5%);">
  <app-nav-bar *ngIf="isLIMSHosted === false" [menuItems]="menuItems"></app-nav-bar>
  <div class="bpt-layout-content-container">
    <div class="bpt-layout-content">       
        <router-outlet></router-outlet>
    </div>
  </div>
</div>
<div  *ngIf="isLIMSHosted === false">
  <bpt-footer  #footerRef class="centered-footer">
  </bpt-footer>
</div>
<div  *ngIf="isLIMSHosted === true" class="eqms-layout-wrapper limsHosted elims-hosted">
  <div class="bpt-layout-content-container">
    <div class="bpt-layout-wrapper">
      <div class="bpt-layout-content">
        <router-outlet></router-outlet>
    </div>
    </div>
  </div>
</div>
